var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1851_2939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6567 2.34325C10.5324 -0.781094 5.46691 -0.781094 2.34322 2.34331C-0.781094 5.46762 -0.781094 10.5331 2.34334 13.6568C5.46691 16.7811 10.5324 16.7811 13.6567 13.6567C16.7811 10.5331 16.7811 5.46763 13.6567 2.34325ZM12.714 12.7139C10.1103 15.3176 5.88912 15.3176 3.28616 12.714C0.682469 10.1109 0.682469 5.88972 3.28609 3.28609C5.88912 0.682437 10.1103 0.682437 12.7139 3.28609C15.3176 5.88975 15.3176 10.1109 12.714 12.7139Z",
    fill: "#E20000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2989 4.70014C11.0385 4.4398 10.6164 4.4398 10.356 4.70014L7.99901 7.05717L5.64198 4.70014C5.38163 4.4398 4.95951 4.4398 4.69916 4.70014C4.43882 4.96048 4.43882 5.38261 4.69916 5.64295L7.0562 7.99998L4.70004 10.3561C4.4397 10.6165 4.4397 11.0386 4.70004 11.299C4.96038 11.5593 5.38251 11.5593 5.64285 11.299L7.99901 8.9428L10.3559 11.2996C10.6162 11.56 11.0383 11.56 11.2987 11.2996C11.559 11.0393 11.559 10.6172 11.2987 10.3568L8.94182 7.99998L11.2989 5.64295C11.5592 5.38261 11.5592 4.96052 11.2989 4.70014Z",
    fill: "#E20000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1851_2939"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/cancelIcon.fb6001818e72c1523e0cb32967ce04da.svg";
export { ForwardRef as ReactComponent };